@if (sliderScene) {
    <div class="slider-props-panel">
        <!-- Main Content -->
        <div class="panel-content">
            <div class="settings-section">
                
                <!-- Navigation Buttons -->
                <app-setting-toggle-group
                    icon="touch_app"
                    title="{{ 'ai.navigationalStyle' | transloco }}"
                    name="navigation"
                    ariaLabel="Navigation Mode"
                    [options]="navigationOptions"
                    [hideSingleSelectionIndicator]="false"
                    [ngModel]="navigationMode"
                    (selectionChange)="onChangeNavigationMode($event)">
                </app-setting-toggle-group>

                <!-- Duration -->
                @if (navigationMode === 'time') {
                    <div class="input-group">
                        <mat-form-field appearance="outline" class="full-width">
                            <mat-label>{{ 'ai.durationSeconds' | transloco }}</mat-label>
                            <input type="number" matInput [formControl]="durationControl" class="hide-spinners">
                            <mat-icon matPrefix>schedule</mat-icon>
                            <span matSuffix>sec</span>
                        </mat-form-field>
                    </div>

                    <div class="playlist-section">
                        <form [formGroup]="group" floatLabel="never">
                            <app-table-list-input matInput required
                                                    [callBackValue]="onCallBackValue()"
                                                    [callBackEvent]="onTableListChangeCallBackBound"
                                                    [keepTableIds]="false"
                                                    [cloneVals]="true"
                                                    [confirmRemove]="false"
                                                    [disableDrag]="false"
                                                    [tableColumns]="tableColumns"
                                                    [inputEditFormat]="{page: 'text', duration: 'number'}"
                                                    [inputEditRenamePath]="[{path: '$.page', key: 'page'}, {path: '$.duration', key: 'duration'}]"
                                                    [tableClassName]="'playlistTableControl'"
                                                    [multiSelect]="false"
                                                    [rememberSelection]="false"
                                                    [allowFilter]="false"
                                                    [buttons]="tableButtons"
                                                    [expandableEditor]="true"
                                                    [formControlName]="'playlistTableControl'">
                            </app-table-list-input>
                        </form>
                    </div>
                }

                @if (showMainLayout && navigationMode === 'slide') {
                    <!-- Navigation Button Size -->
                    <div class="navigation-customization">
                        <div class="setting-item">
                            <div class="setting-header-vertical">
                                <div class="setting-title-row">
                                    <mat-icon class="setting-icon">tune</mat-icon>
                                    <span class="setting-title">{{ 'ai.addActionButtons' | transloco }}</span>
                                </div>
                                <div class="controls-row">
                                    <mat-form-field appearance="outline" class="size-select">
                                        <mat-label>{{ 'ai.size' | transloco }}</mat-label>
                                        <mat-select [(ngModel)]="navigationButtonSize" (selectionChange)="onSizeChange()" [disabled]="!editingSlideSceneId">
                                            @for (option of sizeOptions; track option.value) {
                                                <mat-option [value]="option.value">{{ option.label }}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>

                                    <button
                                        mat-icon-button
                                        class="delete-navigation-btn"
                                        [disabled]="!editingSlideSceneId"
                                        (click)="removeAllNavigation()"
                                        [matTooltip]="'ai.removeAllNavigationButtons' | transloco">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Navigation Menu Section -->
                    <div class="navigation-menu-section">
                        <div class="setting-item">
                            <div class="setting-header-vertical">
                                <div class="setting-title-row">
                                    <mat-icon class="setting-icon">menu</mat-icon>
                                    <span class="setting-title">{{ 'ai.addNavigationMenu' | transloco }}</span>
                                </div>
                                <div class="menu-controls">
                                    <div class="orientation-toggle">
                                        <button mat-icon-button
                                                [class.active]="menuOrientation === 'horizontal'"
                                                (click)="setMenuOrientation('horizontal')"
                                                [matTooltip]="'ai.horizontalMenu' | transloco">
                                            <mat-icon>more_horiz</mat-icon>
                                        </button>
                                        <button mat-icon-button
                                                [class.active]="menuOrientation === 'vertical'"
                                                (click)="setMenuOrientation('vertical')"
                                                [matTooltip]="'ai.verticalMenu' | transloco">
                                            <mat-icon>more_vert</mat-icon>
                                        </button>
                                    </div>
                                    <mat-form-field appearance="outline" class="size-select">
                                        <mat-label>{{ 'ai.size' | transloco }}</mat-label>
                                        <mat-select [(ngModel)]="menuButtonSize">
                                            @for (option of menuSizeOptions; track option.value) {
                                                <mat-option [value]="option.value">{{ option.label }}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="menu-action-buttons">
                                    <button mat-flat-button
                                            class="add-menu-button"
                                            (click)="addNavigationMenu()">
                                        <mat-icon>add_circle_outline</mat-icon>
                                        <span>{{ 'ai.addMenu' | transloco }}</span>
                                    </button>
                                    <button mat-icon-button
                                            class="delete-navigation-btn"
                                            (click)="removeNavigationMenu()"
                                            [matTooltip]="'ai.removeNavigationMenu' | transloco">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                }

                @if (navigationMode === 'slide') {
                    <!-- Add Touch Buttons Section -->
                    <div class="touch-buttons-section">
                        <div class="setting-item">
                            <div class="setting-header-vertical">
                                <div class="setting-title-row">
                                    <mat-icon class="setting-icon">touch_app</mat-icon>
                                    <span class="setting-title">{{ 'ai.addTouchButtons' | transloco }}</span>
                                </div>

                                <div class="action-buttons-container" [class.disabled]="!editingSlideSceneId">
                                    <div cdkDropList cdkDropListSortingDisabled (cdkDropListDropped)="addOrDragActionButton($event)">
                                        <div cdkDrag (cdkDragStarted)="onDragStart()" (cdkDragEnded)="onDragEnd()">
                                            <button mat-flat-button
                                                    class="unified-touch-button d-flex-center"
                                                    (click)="addOrDragActionButton()"
                                                    [disabled]="!editingSlideSceneId">
                                                <mat-icon>add_circle_outline</mat-icon>
                                                <span>{{ 'ai.addTouchAction' | transloco }}</span>
                                                <mat-icon>drag_indicator</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                @if (showMainLayout) {
                    <!-- Selected Slide Name - Moved to Bottom -->
                    <br/>
                    <br/>
                    <div class="input-group">
                        <mat-form-field appearance="outline" class="full-width">
                            <mat-label>slider name</mat-label>
                            <input autocomplete="off" inputrestriction="basic1" matInput
                                   [value]="sliderScene?.Player?.$?.label || ''"
                                   [disabled]="!sliderSceneId"
                                   (change)="onChangeSceneName($event)">
                            <mat-icon matPrefix>edit</mat-icon>
                        </mat-form-field>
                    </div>
                }
            </div>
        </div>
    </div>
}
